import { VStack } from '@chakra-ui/react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from './types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';

export const SelfScheduleCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  submitAttempt,
  selfScheduleTemplateOptions = [],
  fromOptions,
  ccBccOptions,
  selfScheduleVariables,
  uploadInlineImage,
}: InterviewCommPanelBaseProps) => {
  return (
    <VStack align="stretch" spacing="4" w="100%">
      <EmailBlockSection
        title="Self-schedule slot selection email"
        sectionId="interview-comm-self-schedule"
        description="Candidates get this email to select their interview slot for self-schedule interviews."
        // Slot-selection email is always on; toggle hidden until product re-enables it.
        // showSwitch
        // switchChecked={state.selfScheduleEnabled}
        // onSwitchChange={(checked) =>
        //   dispatch({ type: 'SET_SELF_SCHEDULE_ENABLED', payload: checked })
        // }
      >
        {/* {state.selfScheduleEnabled ? ( */}
        <TemplatedEmail
          className="w-full"
          showFrom
          showTo={false}
          showSubject
          enableCcBcc
          showTemplate
          showEditor
          editorVariant="richEmail"
          submitAttempt={submitAttempt}
          variables={selfScheduleVariables}
          attachments={state.selfScheduleAttachments}
          onAttachmentsChange={(items) =>
            dispatch({
              type: 'SET_SELF_SCHEDULE_ATTACHMENTS',
              payload: items,
            })
          }
          templateOptions={selfScheduleTemplateOptions}
          fromOptions={fromOptions}
          ccBccOptions={ccBccOptions}
          applyTemplateBodyToEditor
          value={state.selfSchedule}
          onChange={(value) =>
            dispatch({ type: 'SET_SELF_SCHEDULE', payload: value })
          }
          errors={fieldErrors.selfSchedule}
          placeholders={{
            from: 'Select from',
            subject: 'Subject',
            template: 'Select a template',
          }}
          uploadInlineImage={uploadInlineImage}
        />
        {/* ) : null} */}
      </EmailBlockSection>
    </VStack>
  );
};
